<icon-button icon="favorite" [class.active]="isActive" [class.hidden]="!isFavoritingEnabled" [class.icon-only]="iconOnly"
             (click)="handleToggle($event)" ariaLabel="Favorite"></icon-button>